import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { ModbusTCPServerDto, ModbusTCPServerDtoPOSTorPUTDto } from '../types/modbus-tcp-server.types'

export const getModbusTcpServer = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<Nullable<ModbusTCPServerDto> | null>> => {
  try {
    const response = await authFetch<Nullable<ModbusTCPServerDto>>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/modbus-tcp-server`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<Nullable<ModbusTCPServerDto>>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get Modbus TCP server:')
  }
}

export const createModbusTcpServer = async (
  installationId: number,
  payload: ModbusTCPServerDtoPOSTorPUTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/modbus-tcp-server`,
      method: 'POST',
      payload,
    })

    if (response.status !== StatusCodes.OK && response.status !== StatusCodes.CREATED) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to create Modbus TCP server:')
  }
}

export const updateModbusTcpServer = async (
  installationId: number,
  payload: ModbusTCPServerDtoPOSTorPUTDto,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/modbus-tcp-server`,
      method: 'PUT',
      payload,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update Modbus TCP server:')
  }
}
